<template>
  <v-btn
    color="pwt_palatinate_blue"
    variant="text"
    :disabled="disabled"
    :loading="loading"
    class="text-none rounded-pill text-decoration-underline"
    :class="{ 'px-1': !padded, 'px-5': padded }"
    @click="emitClick"
    style="text-underline-offset: 4px !important"
  >
    <slot></slot>
  </v-btn>
</template>
<script setup lang="ts">
interface Props {
  loading?: boolean
  disabled?: boolean
  padded?: boolean
}

const { loading = false, disabled = false, padded = true } = defineProps<Props>()

const emit = defineEmits(['click'])

function emitClick() {
  emit('click')
}
</script>
